import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about_us.png")